import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { map, Observable } from 'rxjs'
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface'
import { environment } from 'src/environments/environment'
import { getFilterParams } from '../../helpers/get-filters'

@Injectable({
    providedIn: 'root',
})
export class XeroService {
    #httpClient = inject(HttpClient)

    authorize(): Observable<string> {
        return this.#httpClient
            .get<ApiResponse<string>>(`${environment.baseUrl}xero/authorize`)
            .pipe(map((x) => x.result))
    }

    callback(code: string, state: string): Observable<any> {
        return this.#httpClient.post(`${environment.baseUrl}xero/callback?code=${code}&state=${state}`, {})
    }

    disconnect(): Observable<any> {
        return this.#httpClient.post(`${environment.baseUrl}xero/disconnect`, {})
    }

    setDefaultTenantId(tenantId: string): Observable<any> {
        return this.#httpClient.put(`${environment.baseUrl}xero/tenant/${tenantId}`, {})
    }
}
